import { useEffect, useState } from "react"

type Language = {
  selectedLang: string
}

export const useLanguage = () => {
  // Функция, экспортирующаяся из модуля (как хук), для получения языка
  let langKey = process.env.GATSBY_LANG // Получение языка по умолчанию, хранимого в переменной окружения

  if (typeof window === "object") {
    // Проверка, что код выполняется в браузере (а не на сервере)
    if (window.location.pathname.includes("/br/")) {
      // Если текущий путь содержит "/br/", устанавливаем язык "br"
      langKey = "br"
    }
    if (window.location.pathname.includes("/es/")) {
      // Если текущий путь содержит "/es/", устанавливаем язык "es"
      langKey = "es"
    }
  }

  return Translations(langKey || "") // Возвращаем объект языка, полученный с помощью функции Translations
}

export function Translations(langKey: string): Language {
  const [selectedLang, setSelectedLang] = useState(langKey) // Используем useState для сохранения выбранного языка

  useEffect(() => {
    // Используем useEffect для обновления выбранного языка при изменении langKey
    setSelectedLang(langKey)
  }, [langKey])

  const language: Language = {
    selectedLang, // Свойство selectedLang содержит выбранный язык
  }

  return language // Возвращаем язык
}
